import React from 'react'
import { TextareaGroup } from 'components/common'
import { Container } from './CreateQuestion.styles'
import { forms as content } from 'pages/Authenticated/Template/constants/content'
import { useTranslation } from 'react-i18next'

interface Props {
  error?: boolean
  value: string
  handleChange: React.ChangeEventHandler<HTMLTextAreaElement>
}

const CreateQuestionComponent: React.FC<Props> = ({ handleChange, error, value }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <TextareaGroup
        label={t(content.createQuestionLabel)}
        name='question'
        onChange={handleChange}
        value={value}
        error={error}
      />
    </Container>
  )
}

export default CreateQuestionComponent
